module.exports = __webpack_public_path__ + "media/images/modal-close-w@2x-2f150a9a3e4b21bda14cca942df1762c.png";